"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
  Get unique label from an option object. Ex.

  option: {
    groupId: 'Dogs',
    label: 'Corgi',
    value: 'DOG_CORGI'
  }

  Unique label => 'Dogs - Corgi'
*/
var getUniqueLabel = function getUniqueLabel(_ref) {
  var groupId = _ref.groupId,
      label = _ref.label;
  return groupId ? groupId + " - " + label : label;
};

exports.default = getUniqueLabel;